pageLoad('pages_vue', async () => {
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: TestApp } = await import('@/vue/test');

  createApp(TestApp).mount('#app');
});
